<template>
<div class="conteudoInterno">
  <div class="boxSeta">
      <div class="setaScrollstatic" style="" 
          :class="{ 
            setaScroll: setaScrollState 
            }"
      >
        <button><span><i class="bottom"></i></span></button>
      </div> 
  </div>
  <header class="headerSec" >
    <h2>2018 em números</h2>
    <div class="navSetas">
      <button @click="goBack()" :disabled="clicked"><span><i class="left"></i></span></button>
      <button @click="goNext()" :disabled="clicked"><span><i class="right"></i></span></button>
    </div> 
  </header>
  <div class="conteudoInternoBox" ref="infoBox">
    <section class="sectionRow" ref="infoscroll">
      <div class="col23ponto5 marginColBottom">
        <span class="linecol32"></span> 
      </div>
      <div class="col23ponto52 marginColBottom">
        <div class="boxDestUbc">
          <img src="../assets/numerosico1.png" />
          <span class="btubc1">R$ 524,3</span>
          <span class="btubc2">MILHÕES</span>
        </div>
      </div>
      <div class="col23ponto52 marginColBottom">
        <div  class="boxDestUbc">
          <img src="../assets/numerosico2.png" />
          <span class="btubc3">distribuídos a</span>
          <span class="btubc4">186 MIL</span>
          <span class="btubc5">titulares</span>
          <span class="btubc5b">Um crescimento* de <span>25,4%</span></span>
          <span class="btubc5c">no número  de titulares.</span>
        </div>
      </div>
      <div class="col23ponto52 marginColBottom">
        <div  class="boxDestUbc">
          <img src="../assets/numerosico3.png" />
          <span class="btubc6">62% de</span>
          <span class="btubc7">crescimento no</span>
          <span class="btubc8">biênio 17/18</span>
        </div>
      </div>    
    </section>
    <!-- <section class="sectionRow" style="margin:40px 0 60px 0;">
      <div class="col23ponto5"></div>
      <div class="col74ponto5">
        <div class="linhaDestUbc">
          <span>Um crescimento* de <span class="linhaDestUbcSpanDest">25,4%</span> no número de titulares.</span>
        </div>
      </div>
    </section> -->
    <section class="sectionRow" style="margin:60px 0 0 0;">
      <div class="col23ponto5"></div>
      <div class="col32 marginColBottom">
        <div class="boxDestUbcLinha3">
          <div>
            <span class="btubcl1">A UBC</span>
            <span class="btubcl2">representou</span>
            <span class="btubcl3">57%</span>
          </div>
          <div>
            <span class="btubcl4">do total</span>
            <span class="btubcl5">distribuído pelo</span>
            <span class="btubcl6">ECAD</span>
          </div>
        </div>
      </div>
      <div class="col32">
        <div class="boxDestUbcLinha34">
          <div>
            <span class="btubcl341">Crescimento* de</span>
            <span class="btubcl342">49%</span>
            <span class="btubcl343">no digital</span>
          </div>
          <div>
            <span class="btubcl344">e de</span>
          </div>
          <div>
            <span class="btubcl345">504%</span>
            <span class="btubcl346">em cinema</span>
          </div>
        </div>
      </div>
    </section>
    <section class="sectionRow" style="margin:20px 0 0 0;">
      <div class="col23ponto5"></div>
      <div class="col74ponto5">
        <div class="notaNumeros">
          <span>*comparado a 2017</span>
        </div>
      </div>
    </section>
  </div>
</div>
</template>

<script>
export default {
  name: 'ubc2018emNumeros',
  props:['clicked'],
  data() {
    return{
      setaScrollState: false,
    }
  },
  destroyed(){  
    this.myStopFunction();
  },
  mounted () {
    this.showSetaScroll();
  },
  methods:{
    showSetaScroll: function(){
      this.refresh = setInterval(() => {
        let alturaTela = window.innerHeight;
        let alturaDiv = this.$refs.infoBox.clientHeight;
        let boxABB = this.$refs["infoscroll"].getBoundingClientRect();
        if(alturaTela - 50 <= alturaDiv && boxABB.top == 148){
          this.setaScrollState = true
        }else{
          this.setaScrollState = false
        }
      }, 1000);
    },
    myStopFunction: function() {
      clearInterval(this.refresh);
    },
    goNext: function(){
      this.$emit("go-next");
    },
    goBack: function(){
      this.$emit("go-back");
    },  
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>


// WEBPACK FOOTER //
// src/components/ubc2018emNumeros.vue